// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../src/assets/fonts/red-hat-display-v20-latin-regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../src/assets/fonts/red-hat-display-v20-latin-500.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../src/assets/fonts/red-hat-display-v20-latin-900.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
// ─────────────────────────────────────────────────────────────────────────────
// GLOBAL STYLES
// Core stylesheet containing CSS variables, dark mode styles, base element
// styling, typography rules, utility classes, component styles, navigation,
// footer, and other repeated section styles for the entire site
// ───────────────────────────────────────────────────────────────────────────── 
*/

*,
*:before,
*:after {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}

:root {
  --cyan-600: #4d96a9;
  --cyan-300: #8fe3f9;

  --purple-600: #855fb1;
  --purple-300: #d9b8ff;

  --slate-900: #28283d;
  --slate-600: #87879d;
  --slate-300: #d1d1df;

  --white: #fafafa;

  --header-font: "Red Hat Display", Arial, Helvetica, sans-serif;
  --body-font: "Red Hat Display", Arial, Helvetica, sans-serif;

  --section-padding: 4rem 2rem 2rem;
  --section-max-width: 1120; /*do not include units*/
}

html,
body {
  font-family: var(--body-font);
  font-size: 100%; /* unsure why this is necessary */
  overflow-x: hidden;
}

/* Utility Classes */
.topper {
  text-transform: uppercase;
  text-align: inherit;
  color: var(--cyan-600);
  display: block;
}

/* Base Element Styles */
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: var(--header-font);
  color: var(--slate-900);
}

p,
li,
a {
  color: var(--slate-600);
}

a,
button {
  &:hover {
    cursor: pointer;
  }
}

/* ******************* */
/*        FONTS        */
/* ******************* */

/* red-hat-display-regular - latin */
@font-face {
  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
  font-family: "Red Hat Display";
  font-style: normal;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
    format("woff2"); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}
/* red-hat-display-500 - latin */
@font-face {
  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
  font-family: "Red Hat Display";
  font-style: normal;
  font-weight: 500;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___})
    format("woff2"); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}
/* red-hat-display-900 - latin */
@font-face {
  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */
  font-family: "Red Hat Display";
  font-style: normal;
  font-weight: 900;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___})
    format("woff2"); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */
}

/* ******************* */
/*  COMPONENTS & UTILS */
/* ******************* */

.text-preset-1 {
  font-size: 64px;
  font-weight: 900;
  line-height: 1.1em;
  letter-spacing: 0px;
}

.text-preset-2 {
  font-size: 40px;
  font-weight: 900;
  line-height: 1.1em;
  letter-spacing: 0px;
}

.text-preset-3 {
  font-size: 16px;
  font-weight: 900;
  line-height: 1.1em;
  letter-spacing: 4px;
}

.text-preset-4 {
  font-size: 18px;
  font-weight: 500;
  line-height: 1.5em;
  letter-spacing: 0px;
}

.text-preset-5 {
  font-size: 16px;
  font-weight: 900;
  line-height: 1.5em;
  letter-spacing: 0px;
}

/* MOBILE */
@media only screen and (min-width: 0rem) and (max-width: 40rem) {
  .text-preset-1 {
    font-size: 40px;
  }

  .text-preset-2 {
    font-size: 32px;
  }

  .text-preset-3 {
    font-size: 12px;
  }

  .text-preset-4 {
    font-size: 16px;
  }
}

/* TABLET */
@media only screen and (min-width: 40rem) and (max-width: 64rem) {
  .text-preset-1 {
    font-size: 48px;
  }

  .text-preset-2 {
    font-size: 36px;
  }

  .text-preset-3 {
    font-size: 14px;
  }

  .text-preset-4 {
    font-size: 16px;
  }
}

.button-solid {
  z-index: 1;
  position: relative;
  display: inline-block;
  width: auto;
  padding: 1rem 2.5rem;
  text-decoration: none;
  border-radius: 1.8125rem;
  overflow: hidden;
  transition: color 0.3s;
  transition-delay: 0.1s;
  text-align: center;
  color: var(--white);
  &.blue {
    background-color: var(--cyan-600);
    &:hover {
      background-color: #71c0d4;
    }
    .version {
      color: var(--cyan-300);
    }
  }
  &.purple {
    background-color: var(--purple-600);
    &:hover {
      background-color: #b18bdd;
    }
    .version {
      color: var(--purple-300);
    }
  }
}

/* ****** */
/* HEADER */
/* ****** */
header {
  width: 100%;
  padding: 3rem 5rem 0;

  .container {
    margin: 0 auto;
  }

  .logo {
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 118px;
      height: 28px;
      /* ensures the image never overflows the container. It stays contained within it's width and height and expands to fill it then stops once it reaches an edge */
      object-fit: contain;
    }
  }
}

/* ******************* */
/*       DESKTOP       */
/* ******************* */
@media only screen and (min-width: 64rem) {
  header {
    padding-top: 5rem;
  }
}

/* ******************* */
/*         CTA         */
/* ******************* */

/* Mobile - 360px */
@media only screen and (min-width: 0rem) {
  #cta {
    padding: var(--section-padding);
    padding-bottom: 4rem;
    position: relative;

    .container {
      width: 100%;
    }

    .content {
      /* set text align to left if content needs to be left aligned */
      text-align: center;
      width: 100%;
      display: flex;
      flex-direction: column;
      /* centers content horizontally, set to flex-start to left align */
      align-items: center;
      gap: 1.5rem;
    }

    h2 {
      color: var(--white);
    }

    p {
      color: var(--white);
    }

    .picture {
      height: 100%;
      width: 100%;
      display: block;
      position: absolute;
      z-index: -1;
      top: 0;
      left: 0;

      &:before {
        /* color overlay */
        content: "";
        position: absolute;
        display: block;
        height: 100%;
        width: 100%;
        background: var(--cyan-600);
        opacity: 0.9;
        top: 0;
        left: 0;
        z-index: 1;
      }

      img {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        object-fit: cover;
      }
    }
  }
}

/* TABLET */
@media only screen and (min-width: 48rem) {
  #cta {
    .container {
      max-width: calc(504 / 16 * 1rem);
      margin: 0 auto;
    }
  }
}

/* TABLET */
@media only screen and (min-width: 64rem) {
  #cta {
    padding-top: 112px;
    padding-bottom: 112px;
    .container {
      max-width: calc(var(--section-max-width) / 16 * 1rem);
    }
    .content {
      flex-direction: row;
      align-items: flex-start;
      gap: 2rem;
      text-align: start;
    }

    p {
      width: 355px;
    }

    a {
      margin-left: 3.9375rem;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/root.css"],"names":[],"mappings":"AAAA;;;;;;;CAOC;;AAED;;;EAGE,UAAU;EACV,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;;EAEnB,qBAAqB;EACrB,qBAAqB;;EAErB,oBAAoB;EACpB,oBAAoB;EACpB,oBAAoB;;EAEpB,gBAAgB;;EAEhB,8DAA8D;EAC9D,4DAA4D;;EAE5D,iCAAiC;EACjC,yBAAyB,EAAE,uBAAuB;AACpD;;AAEA;;EAEE,6BAA6B;EAC7B,eAAe,EAAE,iCAAiC;EAClD,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;AAChB;;AAEA,wBAAwB;AACxB;;;;;;EAME,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;;EAEE;IACE,eAAe;EACjB;AACF;;AAEA,wBAAwB;AACxB,wBAAwB;AACxB,wBAAwB;;AAExB,oCAAoC;AACpC;EACE,kBAAkB,EAAE,sGAAsG;EAC1H,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB;mBACiB,EAAE,4DAA4D;AACjF;AACA,gCAAgC;AAChC;EACE,kBAAkB,EAAE,sGAAsG;EAC1H,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB;mBACiB,EAAE,4DAA4D;AACjF;AACA,gCAAgC;AAChC;EACE,kBAAkB,EAAE,sGAAsG;EAC1H,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB;mBACiB,EAAE,4DAA4D;AACjF;;AAEA,wBAAwB;AACxB,wBAAwB;AACxB,wBAAwB;;AAExB;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,WAAW;AACX;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,oBAAoB;EACpB,qBAAqB;EACrB,wBAAwB;EACxB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB;IACE,iCAAiC;IACjC;MACE,yBAAyB;IAC3B;IACA;MACE,sBAAsB;IACxB;EACF;EACA;IACE,mCAAmC;IACnC;MACE,yBAAyB;IAC3B;IACA;MACE,wBAAwB;IAC1B;EACF;AACF;;AAEA,WAAW;AACX,WAAW;AACX,WAAW;AACX;EACE,WAAW;EACX,oBAAoB;;EAEpB;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB;MACE,YAAY;MACZ,YAAY;MACZ,+JAA+J;MAC/J,mBAAmB;IACrB;EACF;AACF;;AAEA,wBAAwB;AACxB,wBAAwB;AACxB,wBAAwB;AACxB;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA,wBAAwB;AACxB,wBAAwB;AACxB,wBAAwB;;AAExB,mBAAmB;AACnB;EACE;IACE,+BAA+B;IAC/B,oBAAoB;IACpB,kBAAkB;;IAElB;MACE,WAAW;IACb;;IAEA;MACE,+DAA+D;MAC/D,kBAAkB;MAClB,WAAW;MACX,aAAa;MACb,sBAAsB;MACtB,kEAAkE;MAClE,mBAAmB;MACnB,WAAW;IACb;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,mBAAmB;IACrB;;IAEA;MACE,YAAY;MACZ,WAAW;MACX,cAAc;MACd,kBAAkB;MAClB,WAAW;MACX,MAAM;MACN,OAAO;;MAEP;QACE,kBAAkB;QAClB,WAAW;QACX,kBAAkB;QAClB,cAAc;QACd,YAAY;QACZ,WAAW;QACX,2BAA2B;QAC3B,YAAY;QACZ,MAAM;QACN,OAAO;QACP,UAAU;MACZ;;MAEA;QACE,kBAAkB;QAClB,MAAM;QACN,OAAO;QACP,YAAY;QACZ,WAAW;QACX,iBAAiB;MACnB;IACF;EACF;AACF;;AAEA,WAAW;AACX;EACE;IACE;MACE,gCAAgC;MAChC,cAAc;IAChB;EACF;AACF;;AAEA,WAAW;AACX;EACE;IACE,kBAAkB;IAClB,qBAAqB;IACrB;MACE,qDAAqD;IACvD;IACA;MACE,mBAAmB;MACnB,uBAAuB;MACvB,SAAS;MACT,iBAAiB;IACnB;;IAEA;MACE,YAAY;IACd;;IAEA;MACE,sBAAsB;IACxB;EACF;AACF","sourcesContent":["/* \n// ─────────────────────────────────────────────────────────────────────────────\n// GLOBAL STYLES\n// Core stylesheet containing CSS variables, dark mode styles, base element\n// styling, typography rules, utility classes, component styles, navigation,\n// footer, and other repeated section styles for the entire site\n// ───────────────────────────────────────────────────────────────────────────── \n*/\n\n*,\n*:before,\n*:after {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n\n:root {\n  --cyan-600: #4d96a9;\n  --cyan-300: #8fe3f9;\n\n  --purple-600: #855fb1;\n  --purple-300: #d9b8ff;\n\n  --slate-900: #28283d;\n  --slate-600: #87879d;\n  --slate-300: #d1d1df;\n\n  --white: #fafafa;\n\n  --header-font: \"Red Hat Display\", Arial, Helvetica, sans-serif;\n  --body-font: \"Red Hat Display\", Arial, Helvetica, sans-serif;\n\n  --section-padding: 4rem 2rem 2rem;\n  --section-max-width: 1120; /*do not include units*/\n}\n\nhtml,\nbody {\n  font-family: var(--body-font);\n  font-size: 100%; /* unsure why this is necessary */\n  overflow-x: hidden;\n}\n\n/* Utility Classes */\n.topper {\n  text-transform: uppercase;\n  text-align: inherit;\n  color: var(--cyan-600);\n  display: block;\n}\n\n/* Base Element Styles */\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: var(--header-font);\n  color: var(--slate-900);\n}\n\np,\nli,\na {\n  color: var(--slate-600);\n}\n\na,\nbutton {\n  &:hover {\n    cursor: pointer;\n  }\n}\n\n/* ******************* */\n/*        FONTS        */\n/* ******************* */\n\n/* red-hat-display-regular - latin */\n@font-face {\n  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */\n  font-family: \"Red Hat Display\";\n  font-style: normal;\n  font-weight: 400;\n  src: url(\"../src/assets/fonts/red-hat-display-v20-latin-regular.woff2\")\n    format(\"woff2\"); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */\n}\n/* red-hat-display-500 - latin */\n@font-face {\n  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */\n  font-family: \"Red Hat Display\";\n  font-style: normal;\n  font-weight: 500;\n  src: url(\"../src/assets/fonts/red-hat-display-v20-latin-500.woff2\")\n    format(\"woff2\"); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */\n}\n/* red-hat-display-900 - latin */\n@font-face {\n  font-display: swap; /* Check https://developer.mozilla.org/en-US/docs/Web/CSS/@font-face/font-display for other options. */\n  font-family: \"Red Hat Display\";\n  font-style: normal;\n  font-weight: 900;\n  src: url(\"../src/assets/fonts/red-hat-display-v20-latin-900.woff2\")\n    format(\"woff2\"); /* Chrome 36+, Opera 23+, Firefox 39+, Safari 12+, iOS 10+ */\n}\n\n/* ******************* */\n/*  COMPONENTS & UTILS */\n/* ******************* */\n\n.text-preset-1 {\n  font-size: 64px;\n  font-weight: 900;\n  line-height: 1.1em;\n  letter-spacing: 0px;\n}\n\n.text-preset-2 {\n  font-size: 40px;\n  font-weight: 900;\n  line-height: 1.1em;\n  letter-spacing: 0px;\n}\n\n.text-preset-3 {\n  font-size: 16px;\n  font-weight: 900;\n  line-height: 1.1em;\n  letter-spacing: 4px;\n}\n\n.text-preset-4 {\n  font-size: 18px;\n  font-weight: 500;\n  line-height: 1.5em;\n  letter-spacing: 0px;\n}\n\n.text-preset-5 {\n  font-size: 16px;\n  font-weight: 900;\n  line-height: 1.5em;\n  letter-spacing: 0px;\n}\n\n/* MOBILE */\n@media only screen and (min-width: 0rem) and (max-width: 40rem) {\n  .text-preset-1 {\n    font-size: 40px;\n  }\n\n  .text-preset-2 {\n    font-size: 32px;\n  }\n\n  .text-preset-3 {\n    font-size: 12px;\n  }\n\n  .text-preset-4 {\n    font-size: 16px;\n  }\n}\n\n/* TABLET */\n@media only screen and (min-width: 40rem) and (max-width: 64rem) {\n  .text-preset-1 {\n    font-size: 48px;\n  }\n\n  .text-preset-2 {\n    font-size: 36px;\n  }\n\n  .text-preset-3 {\n    font-size: 14px;\n  }\n\n  .text-preset-4 {\n    font-size: 16px;\n  }\n}\n\n.button-solid {\n  z-index: 1;\n  position: relative;\n  display: inline-block;\n  width: auto;\n  padding: 1rem 2.5rem;\n  text-decoration: none;\n  border-radius: 1.8125rem;\n  overflow: hidden;\n  transition: color 0.3s;\n  transition-delay: 0.1s;\n  text-align: center;\n  color: var(--white);\n  &.blue {\n    background-color: var(--cyan-600);\n    &:hover {\n      background-color: #71c0d4;\n    }\n    .version {\n      color: var(--cyan-300);\n    }\n  }\n  &.purple {\n    background-color: var(--purple-600);\n    &:hover {\n      background-color: #b18bdd;\n    }\n    .version {\n      color: var(--purple-300);\n    }\n  }\n}\n\n/* ****** */\n/* HEADER */\n/* ****** */\nheader {\n  width: 100%;\n  padding: 3rem 5rem 0;\n\n  .container {\n    margin: 0 auto;\n  }\n\n  .logo {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    img {\n      width: 118px;\n      height: 28px;\n      /* ensures the image never overflows the container. It stays contained within it's width and height and expands to fill it then stops once it reaches an edge */\n      object-fit: contain;\n    }\n  }\n}\n\n/* ******************* */\n/*       DESKTOP       */\n/* ******************* */\n@media only screen and (min-width: 64rem) {\n  header {\n    padding-top: 5rem;\n  }\n}\n\n/* ******************* */\n/*         CTA         */\n/* ******************* */\n\n/* Mobile - 360px */\n@media only screen and (min-width: 0rem) {\n  #cta {\n    padding: var(--section-padding);\n    padding-bottom: 4rem;\n    position: relative;\n\n    .container {\n      width: 100%;\n    }\n\n    .content {\n      /* set text align to left if content needs to be left aligned */\n      text-align: center;\n      width: 100%;\n      display: flex;\n      flex-direction: column;\n      /* centers content horizontally, set to flex-start to left align */\n      align-items: center;\n      gap: 1.5rem;\n    }\n\n    h2 {\n      color: var(--white);\n    }\n\n    p {\n      color: var(--white);\n    }\n\n    .picture {\n      height: 100%;\n      width: 100%;\n      display: block;\n      position: absolute;\n      z-index: -1;\n      top: 0;\n      left: 0;\n\n      &:before {\n        /* color overlay */\n        content: \"\";\n        position: absolute;\n        display: block;\n        height: 100%;\n        width: 100%;\n        background: var(--cyan-600);\n        opacity: 0.9;\n        top: 0;\n        left: 0;\n        z-index: 1;\n      }\n\n      img {\n        position: absolute;\n        top: 0;\n        left: 0;\n        height: 100%;\n        width: 100%;\n        object-fit: cover;\n      }\n    }\n  }\n}\n\n/* TABLET */\n@media only screen and (min-width: 48rem) {\n  #cta {\n    .container {\n      max-width: calc(504 / 16 * 1rem);\n      margin: 0 auto;\n    }\n  }\n}\n\n/* TABLET */\n@media only screen and (min-width: 64rem) {\n  #cta {\n    padding-top: 112px;\n    padding-bottom: 112px;\n    .container {\n      max-width: calc(var(--section-max-width) / 16 * 1rem);\n    }\n    .content {\n      flex-direction: row;\n      align-items: flex-start;\n      gap: 2rem;\n      text-align: start;\n    }\n\n    p {\n      width: 355px;\n    }\n\n    a {\n      margin-left: 3.9375rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
